// Omnix/client/ui/EmailTemplateEditor.js
import { ComponentBase } from "../core/ComponentBase.js";

export class EmailTemplateEditor extends ComponentBase {
    constructor(config) {
        super(config);
        this.modalInstance = null;
        this.value = '';
    }

    async initialize() {
        this.container = document.createElement('div');
        this.container.className = 'modal fade';
        this.container.innerHTML = `
            <div class="modal-dialog modal-xl modal-fullscreen-lg-down">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Email Template Editor</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body">
                        <p class="text-muted small">Note: A full rich-text editor (WYSIWYG) will be integrated here in a future update. For now, please use HTML.</p>
                        <textarea class="form-control" style="height: 60vh; font-family: monospace;"></textarea>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" id="save-btn">Save Template Body</button>
                    </div>
                </div>
            </div>
        `;
        this.modalInstance = new bootstrap.Modal(this.container);
        this.textarea = this.container.querySelector('textarea');
        this.container.querySelector('#save-btn').addEventListener('click', () => {
            this.value = this.textarea.value;
            this.emit('saved', this.value);
        });
    }

    // --- ADDED METHOD ---
    render() {
        return this.container;
    }
    // --- END ADDED METHOD ---

    show(initialData) {
        this.setValue(initialData);
        this.modalInstance.show();
    }

    hide() {
        this.modalInstance.hide();
    }

    setValue(data) {
        this.value = (typeof data === 'string' ? data : '') || '';
        if (this.textarea) {
            this.textarea.value = this.value;
        }
    }
}